import { InputAdornment } from "@mui/material"
import { useFilter } from "../../../../../../hooks/filter"
import { InputModel } from "../../../../../../utils/types"
import React, { useEffect, useRef, useState } from "react"
import { icons } from "../../../../../../utils/icons"
import { ListFormRef } from "../../../../../setting/pages/dropDownList/components/form/types"
import { catalog, dropDownListServiceFetch } from "../../../../../../utils/constants/callService"
import { Item, ObjectGeneric, onChange } from "../../../../../../utils/types/generals"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { filterTopLevelItems } from "./constans"
import { DraggableItem } from "./components/catalogOption/components/draggableItem/types"
import { createCatalogBody, updateCatalogBody } from "../../../../../../service/catalog/body"
import { Types } from "../../../../../../utils/enums"
import { formatCatalogById } from "../../../../../../service/catalog/format"



const useBody = ({
    setProviders,
    items,
    setSubCatalog,
    id,
    setItems,
    setItemsFromEndpoint,
    itemsFromEndpoint
}: {
    setProviders: (values: Item[]) => void;
    items: DraggableItem[];
    setSubCatalog: (values: { label: string; value: number; children: { id: number; name: string; }[]; }[]) => void;
    id: string | undefined;
    setItems: (items: DraggableItem[]) => void;
    setItemsFromEndpoint: (items: DraggableItem[]) => void;
    itemsFromEndpoint: DraggableItem[];
}) => {


    const { t } = useTranslation()
    const navigate = useNavigate()
    const [btnLoading, setBtnLoading] = useState(false)
    const [loader, setLoader] = useState(false)
    const [dataCrud, setDataCrud] = useState<ObjectGeneric>({})

    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void,
        butonNext: string
        butonCancel: string,
    }>({
        open: false,
        title: '',
        description: '',
        confirm: () => { },
        butonNext: t('general.confirm'),
        butonCancel: t('general.cancel')
    })

    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const closeOpenSnakbar = () => {
        setOpenSnackbar((prev) => ({
            ...prev,
            open: false,
        }))
    }

    const formRef = useRef<ListFormRef>(null);

    const paginationMain = useFilter({
        formatFilter: {}
    })

    const inputFilter: { [x: string]: InputModel } = {
        search: {
            label: 'catalog.inputs.searchCatalog',
            translate: true,
            name: 'search',
            rest: {
                type: 'alphaNumeric',
                placeholder: "Buscar catálogos"
            },
            value: null,
            wrapChildren: ({ children, id }) => {
                return React.cloneElement(children, {
                    id,
                    InputProps: {
                        ...(children.props.InputProps ?? {}),
                        endAdornment: (
                            <InputAdornment position="end">
                                {icons('search')}
                            </InputAdornment>
                        ),
                    },
                });
            }
        },
    }

    const inputCrud: { [x: string]: InputModel } = {
        catalogName: {
            label: 'catalog.inputs.catalogName',
            translate: true,
            name: 'catalogName',
            type: 'text',
            validate: {
                required: true,
            },
            customeErrors: {
                required: 'catalog.form.crud.catalogName',
            },
            rest: {
                type: 'alphaNumeric',
                inputProps: {
                    maxLength: 500,
                },
                placeholder: "Ingrese el nombre del catálogo"
            },
            value: null,
            size: {
                lg: 12,
                md: 12,
                sm: 12,
                xl: 12,
                xs: 12
            }
        },
    }

    const getProviders = async () => {

        const response = await dropDownListServiceFetch.getAllDropList();

        const catalogs = !response.errors
            ? response?.map((catalog) => {
                return {
                    label: catalog.name,
                    value: catalog.id,
                    children: catalog.children
                }
            })
            : []

        setSubCatalog(catalogs)
    }

    const getDropLists = async () => {

        const response = await catalog.userList()

        const users = !response.errors
            ? response?.map((user) => {
                return {
                    label: `${user.firstName} ${user.lastName}`,
                    value: user.id,
                }
            }) as Item[]
            : []

        setProviders(users)
    }

    const handleCancel = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            butonNext: t('general.confirm'),
            butonCancel: t('general.cancel'),
            title: t('catalog.modal.cancel.title'),
            description: t('catalog.modal.cancel.description'),
            confirm: () => {
                navigate('../')
                closeModal()
            }
        }))
    }

    const closeModal = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const onChangeCrud: onChange = ({ target }) => {
        const { name, value } = target
        setDataCrud((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleDisabled = () => !items.length || !dataCrud.catalogName

    const handleAllSubmit = async () => {
        setBtnLoading(true)
        if (id) {
            // Editar catalogo
            const body = updateCatalogBody({ catalogName: String(dataCrud.catalogName), items, itemsFromEndpoint })

            const response = await catalog.updateCatalog(body,id)

            if (!response.errors) {
                setOpenSnackbar((prev) => ({
                    ...prev,
                    message: t('catalog.snackbar.edit.success'),
                    type: Types.SUCCESS,
                    open: true,
                }))
                setTimeout(() => {
                    navigate('../');
                    setItems([]);
                }, 3000);
            } else {
                setOpenSnackbar((prev) => ({
                    ...prev,
                    message: t('catalog.snackbar.edit.error'),
                    type: Types.ERROR,
                    open: true,
                }))
            }
        } else {
            // Crear catalogo
            const body = createCatalogBody({ catalogName: String(dataCrud.catalogName), items })
            const response = await catalog.createCatalog(body)

            if (!response.errors) {
                setOpenSnackbar((prev) => ({
                    ...prev,
                    message: t('catalog.snackbar.create.success'),
                    type: Types.SUCCESS,
                    open: true,
                }))
                setTimeout(() => {
                    navigate('../');
                    setItems([]);
                }, 3000);
            } else {
                setOpenSnackbar((prev) => ({
                    ...prev,
                    message: t('catalog.snackbar.create.error'),
                    type: Types.ERROR,
                    open: true,
                }))
            }
        }
        //navigate('../')
        setBtnLoading(false)
    }

    const getCatalog = async () => {
        setLoader(true)

        const response = await catalog.getCatalogById(id as string)

        const { catalogName, items } = formatCatalogById({ response })

        setDataCrud({  catalogName: catalogName, })
        setItems(items)
        setItemsFromEndpoint(items)


        setLoader(false)
    }

    const filteredItems = filterTopLevelItems(items, paginationMain.filterData.search ?? '');

    useEffect(() => {
        getProviders()
        getDropLists()
    }, [/* id */])

    useEffect(() => {
        setItems([])
        setItemsFromEndpoint([])
        if (id) {
            getCatalog()
        }
    }, [id])



    return {
        paginationMain,
        inputFilter,
        formRef,
        handleCancel,
        modal,
        closeModal,
        loader,
        btnLoading,
        handleDisabled,
        handleAllSubmit,
        filteredItems,
        inputCrud,
        onChangeCrud,
        dataCrud,
        openSnackbar,
        closeOpenSnakbar
    }
}


export { useBody }